import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { PAGE_SCROLL_ID } from '@backrs_ui/grow-ui/src/components/PageShell/pageShell.layout';
import { scrollPageToTop } from '@backrs_ui/grow-ui/src/utils/scrollReveal';

export const usePageScroll = (showResourceContent: boolean) => {
  const { pathname, hash } = useLocation();
  const savedRef = useRef({ pathname: '', top: 0 });

  useEffect(() => {
    // A hash points at an in-page anchor, which owns the scroll position.
    if (hash) return;

    scrollPageToTop();
  }, [pathname, hash]);

  // The page stays mounted (hidden) behind shell tabs and shares their scroller, so its offset is
  // saved while a tab shows and restored when the tab closes.
  useLayoutEffect(() => {
    const scroller = document.getElementById(PAGE_SCROLL_ID);

    if (!scroller) return;

    if (showResourceContent) {
      scroller.scrollTop = 0;

      return;
    }

    if (savedRef.current.pathname === pathname) {
      scroller.scrollTop = savedRef.current.top;
    }

    const trackScroll = () => {
      savedRef.current = { pathname, top: scroller.scrollTop };
    };

    scroller.addEventListener('scroll', trackScroll, { passive: true });

    return () => scroller.removeEventListener('scroll', trackScroll);
  }, [showResourceContent, pathname]);
};
